<template>
  <div style="width: 100%" class="fx-row fx-row-middle">
    <div class="text" v-if="!chartData.length">暂无数据</div>
    <div :id="chartId" style="width: 100%; height: 300px"></div>
  </div>
</template>
<script>
import echarts from 'echarts';
import debounce from 'lodash/debounce';
export default {
  props: {
    chartId: String,
    chartData: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      myChart: null,
      hasData: false,
      chartOption: {
        legend: {},
        tooltip: {
          trigger: 'item'
        },
        xAxis: { type: 'category', data: [] },
        yAxis: { type: 'value' },
        series: [
          {
            type: 'line',
            name: '',
            smooth: true,
            seriesLayoutBy: 'row',
            emphasis: { focus: 'series' },
            data: [],
            itemStyle: {
              color: '#1e6bd9'
            }
          }
        ]
      }
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(newVal) {
        this.setOption(newVal);
      }
    }
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.myChart = echarts.init(document.getElementById(`${this.chartId}`));
      if (this.myChart) {
        this.myChart.resize();
      }
      this.resizeHandler = debounce(() => {
        if (this.myChart) {
          this.myChart.resize();
        }
      }, 100);
      window.addEventListener('resize', this.resizeHandler);
    },
    resize() {
      this.myChart.resize();
    },
    setOption(list) {
      this.hasData = true; // data && data.length;
      if (!this.hasData) return;
      let option = Object.assign({}, this.chartOption);
      let xAxisData = [],
        yAisData = [];
      list.map(item => {
        xAxisData.push(item.time);
        yAisData.push(item.count);
      });
      option.xAxis.data = xAxisData;
      option.series[0].data = yAisData;
      //   option.series[1].data = [];
      //   callback(data, option, type);
      this.myChart.setOption(option);
    }
  },
  beforeDestroy() {
    if (!this.myChart) {
      return;
    }
    this.myChart.dispose();
    this.myChart = null;
    window.removeEventListener('resize', this.resizeHandler);
  }
};
</script>
<style lang="less" scoped>
.text{
  text-align: center;
  line-height: 240px;
  color:#aaa;
}
</style>
